function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import classnames from 'classnames';

var DsLogoProgressComp = function DsLogoProgressComp(_ref) {
  var classes = _ref.classes,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      others = _objectWithoutProperties(_ref, ["classes", "size"]);

  var shapeCenterClassName = classnames(classes.shape, classes.shapeCenter);
  var shapeLeftClassName = classnames(classes.shapeLeft, classes.shape);
  var shapeTopClassName = classnames(classes.shapeTop, classes.shape);
  var shapeRightClassName = classnames(classes.shapeRight, classes.shape);
  var shapeBottomClassName = classnames(classes.shapeBottom, classes.shape);
  var spinnerSize;

  switch (size) {
    case 'small':
      spinnerSize = 25;
      break;

    case 'medium':
      spinnerSize = 50;
      break;

    case 'large':
      spinnerSize = 100;
      break;

    default:
      break;
  }

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      className: classes.root
    }, others, {
      width: spinnerSize,
      height: spinnerSize,
      viewBox: "0 0 60.7 60.7"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      id: "center",
      className: shapeCenterClassName,
      d: "M30.352,11.706A18.649,18.649,0,1,0,48.994,30.355,18.669,18.669,0,0,0,30.352,11.706Zm0,29.2A10.554,10.554,0,1,1,40.9,30.355,10.566,10.566,0,0,1,30.352,40.909Z"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      id: "left",
      className: shapeLeftClassName,
      d: "M13.139,45.047a22.584,22.584,0,0,1-.064-29.308L10.336,13l-2.721-2.72a30.278,30.278,0,0,0,.064,40.229L10.4,47.786Z"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      id: "top",
      className: shapeTopClassName,
      d: "M15.513,13.272A22.578,22.578,0,0,1,45.04,13.14L47.779,10.4,50.5,7.68a30.277,30.277,0,0,0-40.447.13l2.723,2.722Z"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      id: "right",
      className: shapeRightClassName,
      d: "M50.237,12.852,47.5,15.589A22.584,22.584,0,0,1,47.432,45.2l2.74,2.739,2.72,2.721a30.293,30.293,0,0,0,.066-40.527Z"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      id: "bottom",
      className: shapeBottomClassName,
      d: "M44.966,47.633a22.579,22.579,0,0,1-29.378-.127l-2.74,2.738-2.721,2.721a30.269,30.269,0,0,0,40.3.129L47.7,50.372Z"
    }))
  );
};

var styles = function styles(theme) {
  var opacityFrom = 0.4;
  var opacityTo = 1;
  return {
    root: {
      '& *': {
        animationDuration: '1s',
        animationIterationCount: 'infinite',
        animationTimingFunction: 'linear'
      }
    },
    shape: {
      fill: theme.ds.palette.neutral.dark,
      opacity: opacityFrom
    },
    shapeCenter: {
      opacity: opacityTo
    },
    shapeLeft: {
      animationName: '$shapeLeft_Animation'
    },
    shapeTop: {
      animationName: '$shapeTop_Animation'
    },
    shapeRight: {
      animationName: '$shapeRight_Animation'
    },
    shapeBottom: {
      animationName: '$shapeBottom_Animation'
    },
    '@keyframes shapeLeft_Animation': {
      '0%': {
        opacity: opacityTo
      },
      '25%': {
        opacity: opacityFrom
      },
      '100%': {
        opacity: opacityTo
      }
    },
    '@keyframes shapeTop_Animation': {
      '25%': {
        opacity: opacityTo
      },
      '50%': {
        opacity: opacityFrom
      }
    },
    '@keyframes shapeRight_Animation': {
      '50%': {
        opacity: opacityTo
      },
      '75%': {
        opacity: opacityFrom
      }
    },
    '@keyframes shapeBottom_Animation': {
      '75%': {
        opacity: opacityTo
      },
      '100%': {
        opacity: opacityFrom
      }
    }
  };
};

export var DsLogoProgress = withStyles(styles)(DsLogoProgressComp);